import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SocialAccounts from '../components/social-accounts-view';
import appconfig from 'config/appconfig';
import {
  socialProviderByUserIdDelete,
  setModeDisconnectLastSocialAccount,
} from 'modules/social-module';
import {
  meData,
  getGetGoSchema,
  meIsLoading,
} from 'modules/me-module';
import { uiShowToastrMessage } from 'modules/ui-module';
import { getSocialAccountName } from 'lib/utility-functions';
import Session from 'lib/session';

export class SocialAccountsContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      personData: Object.assign({}, this.props.personData),
      socialAccounts: [],
      errors: {},
      isDirty: false,
      modalIsOpen: false,
    };
  }

  openModal = () => {
    this.setState({modalIsOpen: true});
  };

  closeModal = () => {
    this.setState({modalIsOpen: false});
  };

  getSocialAccountIdByProvider = (provider) => {
    const socialAccount = this.props.socialAccounts.find((socialAcct) => socialAcct['provider'] === provider);
    return typeof socialAccount !== 'undefined' ? socialAccount.email : '';
  };

  displayToastrMessage = (toastrType, toastrMessageId, toastrParams = null) => {
    this.props.uiShowToastrMessage(toastrType, toastrMessageId, toastrParams);
  };

  deleteSocialAccountWithToastrMessage = socialAccount => {
    this.socialAccountName = getSocialAccountName(socialAccount);
    this.props.socialProviderByUserIdDelete(this.props.personData.id, socialAccount)
      .then(
        () => {
          this.displayToastrMessage('success',
            'social-accounts.account-disconnect-successful',
            {socialAccountName: this.socialAccountName},
          );
        },
        () => {
          this.displayToastrMessage('error',
            'social-accounts.account-disconnect-failed',
            {socialAccountName: this.socialAccountName},
          );
        },
      );
  };

  // currying, because function calls with params assigned to onClick events are called immediately
  // (https://www.sitepoint.com/currying-in-functional-javascript/)
  disconnectSocialAccount = socialAccount => e => {
    if (typeof e !== 'undefined') {
      e.stopPropagation();
      e.preventDefault();
    }

    if (this.props.socialAccounts.length > 1 || this.props.passwordSet) {
      this.deleteSocialAccountWithToastrMessage(socialAccount);
    } else {
      this.props.setModeDisconnectLastSocialAccount(socialAccount);
    }
    // always return false so that the anchor tag will not try to navigate to the empty location (#).
    return false;
  };

  componentDidUpdate = () => {
    const socialAccount = Session.getItem(appconfig.storage.disconnectSocialAccount);
    if (socialAccount && (this.props.passwordSet || (this.props.socialAccounts && this.props.socialAccounts.length > 1))) {
      this.deleteSocialAccountWithToastrMessage(socialAccount);
      Session.removeItem(appconfig.storage.disconnectSocialAccount);
    }
  };

  render() {
    return (
      <SocialAccounts
        googleEmail={this.getSocialAccountIdByProvider(appconfig.socialAccounts.GOOGLE)}
        googleLink={this.props.socialSignInLinks[appconfig.socialAccountLinks.GOOGLE]}
        facebookEmail={this.getSocialAccountIdByProvider(appconfig.socialAccounts.FACEBOOK)}
        facebookLink={this.props.socialSignInLinks[appconfig.socialAccountLinks.FACEBOOK]}
        linkedinEmail={this.getSocialAccountIdByProvider(appconfig.socialAccounts.LINKEDIN)}
        linkedinLink={this.props.socialSignInLinks[appconfig.socialAccountLinks.LINKEDIN]}
        microsoftEmail={this.getSocialAccountIdByProvider(appconfig.socialAccounts.MICROSOFT)}
        microsoftLink={this.props.socialSignInLinks[appconfig.socialAccountLinks.MICROSOFT]}
        lastpassEmail={this.getSocialAccountIdByProvider(appconfig.socialAccounts.LASTPASS)}
        lastpassLink={this.props.socialSignInLinks[appconfig.socialAccountLinks.LASTPASS]}
        appleEmail={this.getSocialAccountIdByProvider(appconfig.socialAccounts.APPLE)}
        appleLink={this.props.socialSignInLinks[appconfig.socialAccountLinks.APPLE]}
        disconnectSocialAccount={this.disconnectSocialAccount}
      />
    );
  }
}

SocialAccountsContainer.propTypes = {
  personData: PropTypes.object.isRequired,
  socialAccounts: PropTypes.array.isRequired,
  socialProviderByUserIdDelete: PropTypes.func.isRequired,
  socialSignInLinks: PropTypes.object.isRequired,
  setModeDisconnectLastSocialAccount: PropTypes.func.isRequired,
  passwordSet: PropTypes.bool.isRequired,
  uiShowToastrMessage: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  let passwordSet = false;
  const getGoSchema = getGetGoSchema(state);
  if (getGoSchema && getGoSchema.passwordSet) {
    passwordSet = getGoSchema.passwordSet;
  }
  return {
    personData: meData(state),
    isLoading: meIsLoading(state),
    passwordSet,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  socialProviderByUserIdDelete: (userId, socialAccount) => dispatch(socialProviderByUserIdDelete(userId, socialAccount)),
  setModeDisconnectLastSocialAccount: (socialAccount) => dispatch(setModeDisconnectLastSocialAccount(socialAccount)),
  uiShowToastrMessage: (toastrType, toastrMessageId, toastrParams) => dispatch(uiShowToastrMessage(toastrType, toastrMessageId, toastrParams)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SocialAccountsContainer);
